import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { Search } from "@mui/icons-material";
import { Switch, Button, message, Avatar } from "antd";
import AddUser from "./Modal/AddUser";
import UserTable from "./UserTable";
import DeleteConfirmationModal from './Modal/DeleteConfirmationModal';
import AppstoreAddOutlined from '@ant-design/icons/AppstoreAddOutlined';
import onboardingBin from "../../assets/images/OnboardingBin.png";
import "../../css/userManage.css";  // Import the CSS file
import { deleteUser, getUserDetails } from "../../features/UserManagement/UserManagementSlice";
import AssignModal from "./Modal/AssignModal";

function UserManagementArea() {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 7,
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);
  const [visible, setVisible] = useState(false);
  const [usernameDelete, setUsernameDelete] = useState(null);

  const [assignModalVisible, setAssignModalVisible] = useState(false);
  const [recordToAssign, setRecordToAssign] = useState('');
  const [usernameAssign, setUsernameAssign] = useState('');
  const { userDetails } = useSelector((state) => state.userDetails);

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch]);


  const handleTableChange = (pagination) => {
    setPagination(pagination);
    // dispatch(fetchUsers({ search: searchValue, page: pagination.current }));
  };

  const handleDelete = (username, id) => {
    setUsernameDelete(username);
    setRecordToDelete(id);
    setIsModalVisible(true);
  };

  const handleAssignModal = (username, id) => {
    console.log(username)
    setUsernameAssign(username);
    setRecordToAssign(id);
    setAssignModalVisible(true);
  };

  const handleDeleteOk = () => {
    if (recordToDelete) {
      dispatch(deleteUser(recordToDelete))
        .then(() => {
          message.success("User deleted successfully.", 3);
          dispatch(getUserDetails())
        })
        .catch((error) => {
          console.error('Failed to delete user:', error);
        });
    }
    setIsModalVisible(false);
    setRecordToDelete(null);
  };

  const handleDeleteCancel = () => {
    setIsModalVisible(false);
    setRecordToDelete(null);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
      render: (text, record) => (
        <div className="user-avatar">
          {/* <Avatar
            onClick={() => console.log(record?.profile_pic_url)}
            src={record?.profile_pic_url}
          /> */}
          {text} {record.last_name}
        </div>
      ),
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      render: (text, record) => (
        <div className="user-avatar">
          {/* <Avatar
            onClick={() => console.log(record.profile_pic_url)}
            src={record.profile_pic_url}
          /> */}
          {text}
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "User Type",
      dataIndex: "groups__name",
      key: "groups__name",
    },
    // {
    //   title: "Assign Vessels",
    //   dataIndex: "vessel",
    //   key: "vessel",
    //   render: (_, record) => (
    //     <Button className="purple-row" onClick={() => handleAssignModal(record.username, record.id)}>
    //       <AppstoreAddOutlined />
    //     </Button>
    //   ),
    // },
    {
      title: "",
      dataIndex: "bin",
      key: "bin",
      render: (_, record) => (
        <Button className="purple-row" onClick={() => handleDelete(record.username, record.id)}>
          <img
            src={onboardingBin}
            alt="Bin Btn"
            className="bin-image"
          />
        </Button>
      ),
    },

  ];

  const showModal = () => {
    setVisible(true);
  };

  const handleSearch = () => {
    setPagination({ ...pagination, current: 1 }); // Reset pagination to the first page
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // Filtered userDetails based on searchValue
  const filteredData = userDetails.filter((user) =>
    `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleCancel = () => {
    setVisible(false);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleAssignCancel = () => {
    setAssignModalVisible(false);
  };

  const handleAssignOk = () => {
    setAssignModalVisible(false);
  };

  return (
    <div className="uma_main">
      <div className="uma_container">
        <div className="uma_elem1">
          <div className="uma_elem1_left">
            <span>Total User ({userDetails.length})</span>
          </div>
          <div className="uma_elem1_right">
            <div className="uma_search_box">
              <div className="uma-search-bar">
                <input
                  className="uma-search-input"
                  type="text"
                  placeholder="Search here..."
                  onChange={(e) => setSearchValue(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                {/* <Search className="uma-search-icon" onClick={handleSearch} /> */}
              </div>
            </div>
            <div>
              <Button
                type="primary"
                className="add-user-button"
                onClick={showModal}
              >
                ADD
              </Button>
            </div>
          </div>
        </div>

        <div className="uma_elem2">
          <UserTable
            columns={columns}
            data={filteredData}
            pagination={pagination}
            onChange={handleTableChange}
          />

          <DeleteConfirmationModal
            visible={isModalVisible}
            onOk={handleDeleteOk}
            onCancel={handleDeleteCancel}
            message={`Are you sure you want to delete user ${usernameDelete}?`}
          />
        </div>
      </div>

      <AddUser
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
      />
      <AssignModal
        visible={assignModalVisible}
        onOk={handleAssignOk}
        onCancel={handleAssignCancel}
        recordToAssign={recordToAssign}
        usernameAssign={usernameAssign}
      />
    </div>
  );
}

export default UserManagementArea;
